import * as yup from 'yup';
import { isStoredPhoneValue } from './phone-number';

export function optionalStoredPhone() {
  return yup
    .string()
    .nullable()
    .notRequired()
    .test('stored-phone', 'errors.pattern', value => isStoredPhoneValue(value ?? '', false));
}

export function requiredStoredPhone(requiredMessage: string, patternMessage: string) {
  return yup
    .string()
    .required(requiredMessage)
    .test('stored-phone', patternMessage, value => isStoredPhoneValue(value, true));
}
